// inv/src/pages/authentication/ForgotPasswordPage.jsx
import { useState } from 'react';
import { API_URL } from '../../config';
import { useTranslation } from 'react-i18next';
import { Input } from "../../components/ui/input";
import axios from 'axios';
import LoginGoogleButton from './LoginGoogleButton';
import { collectGAContext } from '../../service-scripts/gaContext';

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isGoogleAccount, setIsGoogleAccount] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    console.log('Form submitted!');

    const emailToSend = email.trim();
    console.log('Email to send:', emailToSend);

    if (!emailToSend) {
      console.log('Email is empty, showing error');
      setErrorMessage('Please enter your email address');
      return;
    }

    console.log('Setting loading state...');
    setMessage('');
    setErrorMessage('');
    setIsGoogleAccount(false);
    setIsLoading(true);

    try {
      console.log('Getting GA context...');
      let client_id = null;
      try {
        const gaContext = await collectGAContext();
        client_id = gaContext.client_id;
        console.log('GA context received:', gaContext);
      } catch (gaError) {
        console.warn('GA context error:', gaError);
      }

      const url = client_id
        ? `${API_URL}/forgot-password?client_id=${encodeURIComponent(client_id)}`
        : `${API_URL}/forgot-password`;

      console.log('Sending request to:', url);
      const response = await axios.post(url, { email: emailToSend }, { withCredentials: true });
      console.log('Response received:', response.data);
      setMessage(response.data.message);
    } catch (error) {
      console.error('Error in forgot password:', error);
      if (error.response) {
        const errorType = error.response.data.errorType;

        if (errorType === 'googleAccount') {
          setErrorMessage('It looks like your account is linked with Google. Please log in using Google.');
          setIsGoogleAccount(true);
        } else if (errorType === 'notFound') {
          setErrorMessage('User with this email not found.');
        } else {
          setErrorMessage('Error sending password reset email.');
        }
      } else {
        setErrorMessage('Error sending password reset email.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-8 flex items-start justify-center pt-10">
      <div className="w-full max-w-md bg-white rounded-lg shadow sm:max-w-md xl:p-0">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          <h2 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl  text-left">
            {t('pageLogin.t7')}
          </h2>
          <form className="space-y-4 md:space-y-6" onSubmit={handleForgotPassword}>
            <div>
              <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 ">
                {t('pageLogin.t8')}
              </label>
              <Input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="name@company.com"
                required
                disabled={isLoading}
                multi={false}
              />
            </div>
            <button
              type="submit"
              disabled={isLoading}
              onClick={() => console.log('Button clicked!')}
              className="cursor-pointer w-full px-4 py-2 text-sm font-medium text-white bg-stone-900 rounded-lg hover:bg-stone-800 focus:ring-4 focus:outline-none focus:ring-stone-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Sending...' : t('pageLogin.t9')}
            </button>
          </form>
          {message && <p className="text-green-500">{message}</p>}
          {errorMessage && (
            <div>
              <p className="text-red-500">{errorMessage}</p>
              {isGoogleAccount && (
                <div className="mt-4">
                  <LoginGoogleButton />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;